import { z } from "zod";

export const profileSchema = z.object({
  name: z.string().min(1, "Nama wajib diisi"),
  email: z.string().email("Email tidak valid").min(1, "Email wajib diisi"),
});

export type ProfileValues = z.infer<typeof profileSchema>;

export const profileInitial: ProfileValues = {
  name: "",
  email: "",
};

export const passwordSchema = z
  .object({
    currentPassword: z.string().min(6, "Password saat ini minimal 6 karakter"),
    newPassword: z.string().min(6, "Password baru minimal 6 karakter"),
    confirmPassword: z.string().min(1, "Konfirmasi password wajib diisi"),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Konfirmasi password baru tidak cocok",
    path: ["confirmPassword"],
  });

export type PasswordValues = z.infer<typeof passwordSchema>;

export const passwordEmpty: PasswordValues = {
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
};
